/**
 * Sales Completeness Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { salesCompletenessService } from '../services/completeness.service';
import type { PosReceiptGapsQueryParams, SalesCompletenessQueryParams } from '@bstock/shared';

/** Etat de complétude des ventes, par site (mis a jour chaque nuit) */
export function useSalesCompleteness(params: SalesCompletenessQueryParams, enabled = true) {
  return useQuery({
    queryKey: ['sales-completeness', params],
    queryFn: () => salesCompletenessService.getSalesCompleteness(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}

/** Numeros de tickets manquants d'un site */
export function useReceiptGaps(params: PosReceiptGapsQueryParams, enabled = true) {
  return useQuery({
    queryKey: ['receipt-gaps', params],
    queryFn: () => salesCompletenessService.getReceiptGaps(params),
    enabled,
  });
}
